import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
const without = ['Blank practice pages you still have to fill in', 'Calendars and rosters, no content', 'No progressions, so the order is still your call', 'Nothing to hand a parent who questions a placement', 'You keep paying in unpaid hours'];
const withIt = ['Practices written out, block by block', '300+ pages of drills, scripts and progressions', 'Levels 1–6 in a safe, documented order', 'Scorecards, contracts and templates included', "Open it the night before and you're done"];
export function ValueStack() {
  return <section aria-labelledby="vs-heading" className="w-full bg-white" data-id="element-226" data-mp="2980ev2lht38o">
      <div className="max-w-4xl mx-auto px-5 py-16 sm:py-20" data-id="element-227" data-mp="2d8snpuqgd64f">
        <div className="text-center" data-id="element-228" data-mp="2d6zj0kzegvz2">
          <p className="text-[11px] font-bold uppercase tracking-[1.6px] text-gold-deep" data-id="element-229" data-mp="30yn3ak25p8sd">
            Why this isn&apos;t another planner
          </p>
          <h2 id="vs-heading" className="mt-3 font-display font-bold uppercase text-ink text-3xl sm:text-5xl" data-id="element-230" data-mp="35qo8jm0wpz8w">
            Blank pages vs{' '}
            <span className="text-crimson-deep" data-id="element-231" data-mp="1ohbcyb2wxajn">written practices</span>
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-base text-ink-soft" data-id="element-232" data-mp="235fydmtco064">
            Every cheer planner on the market sells you organization. Organizing
            was never the hard part — deciding what to actually run on Tuesday
            was.
          </p>
        </div>

        {/* Two columns at every width, like the reference — never stacks */}
        <div className="mt-8 grid grid-cols-2 overflow-hidden rounded-2xl border border-ice-dark" data-id="element-233" data-mp="286c5e99002fr">
          <div className="bg-ice px-3.5 py-4 sm:p-6" data-id="element-234" data-mp="2m1o7x2teax78">
            <h3 className="font-display text-base uppercase tracking-wide text-ink-soft sm:text-xl" data-id="element-235" data-mp="2h5z5mrpzr278">
              A $23 coach planner
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-236" data-mp="rru981nhpykl">
              {without.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] leading-snug text-ink-soft sm:text-sm" data-id="element-237" data-mp="mt9a65jz5kxq">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-crimson/15" data-id="element-238" data-mp="2rsshdv0jj3f2">
                    <XIcon className="h-2.5 w-2.5 text-crimson-deep" aria-hidden="true" data-id="element-239" data-mp="2vvyjqrkj8ag9" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
          <div className="bg-navy px-3.5 py-4 text-white sm:p-6" data-id="element-240" data-mp="3apjypywiv8gh">
            <h3 className="font-display text-base uppercase tracking-wide text-gold sm:text-xl" data-id="element-241" data-mp="3fhbi9ph9gdx4">
              Cheer Coach Pro
            </h3>
            <ul className="mt-3.5 grid gap-2.5" data-id="element-242" data-mp="3jin7vv04wz5b">
              {withIt.map(item => <li key={item} className="flex items-start gap-2 text-[12.5px] font-medium leading-snug sm:text-sm" data-id="element-243" data-mp="3ok2vnutp5jre">
                  <span className="mt-0.5 flex h-4 w-4 flex-none items-center justify-center rounded-full bg-gold/20" data-id="element-244" data-mp="7gf3fbnn5dvc">
                    <CheckIcon className="h-2.5 w-2.5 text-gold-hover" aria-hidden="true" data-id="element-245" data-mp="2gap9sa7gv8a" />
                  </span>
                  {item}
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}